import { api } from 'redux/api/index.api';

export const modulesApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchOrganizationModules: builder.query({
      query: ({ organizationId, searchTerm = '', limit = 100, offset = 0 }) => ({
        url: `organizations/${organizationId}/modules/filters?limit=${limit}&offset=${offset}`,
        method: 'POST',
        body: JSON.stringify({
          search_term: searchTerm,
          visibility: null,
          creator_ids: null,
        }),
      }),
      providesTags: ['Modules'],
    }),
    fetchWorkspaceModules: builder.query({
      query: ({ organizationId, workspaceId, searchTerm = '', limit = 100, offset = 0 }) => ({
        url: `organizations/${organizationId}/workspaces/${workspaceId}/modules/filters?limit=${limit}&offset=${offset}`,
        method: 'POST',
        body: JSON.stringify({
          search_term: searchTerm,
          visibility: null,
          creator_ids: null,
        }),
      }),
      providesTags: ['Modules'],
    }),
    fetchModuleSuggestions: builder.query({
      query: ({ organizationId, workspaceId, limit = 100, offset = 0 }) => ({
        url: workspaceId
          ? `organizations/${organizationId}/workspaces/${workspaceId}/modules/suggestions?limit=${limit}&offset=${offset}`
          : `organizations/${organizationId}/modules/suggestions?limit=${limit}&offset=${offset}`,
        method: 'GET',
      }),
    }),
    updateModulesVisibility: builder.mutation({
      query: ({ organizationId, workspaceId, moduleId, visibility }) => ({
        url: workspaceId
          ? `organizations/${organizationId}/workspaces/${workspaceId}/modules/bulk-visibility-update`
          : `organizations/${organizationId}/modules/bulk-visibility-update`,
        method: 'PUT',
        body: {
          module_ids: [moduleId],
          visibility,
        },
      }),
      invalidatesTags: ['Modules'],
    }),
    linkFormsToModule: builder.mutation({
      query: ({ organizationId, workspaceId, moduleId, formIds, parentId }) => ({
        url: workspaceId
          ? `organizations/${organizationId}/workspaces/${workspaceId}/modules/${moduleId}/link-forms`
          : `organizations/${organizationId}/modules/${moduleId}/link-forms`,
        method: 'POST',
        body: {
          form_ids: formIds,
          parent_id: parentId,
        },
      }),
      invalidatesTags: ['Modules'],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchOrganizationModulesQuery,
  useFetchWorkspaceModulesQuery,
  useFetchModuleSuggestionsQuery,
  useUpdateModulesVisibilityMutation,
  useLinkFormsToModuleMutation,
} = modulesApi;
